import { Box } from '@factorialco/deprecated-design-system'
import { ContractTaxonomyFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { observer } from 'mobx-react'

import type Employee from 'modules/employees/store/models/Employee'
import type SupplementsFormStore from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/store'

import FormGroups from './FormGroups'

interface Props {
  employee: Employee
  effectiveOn: moment.Moment
  store: SupplementsFormStore
  taxonomies: ContractTaxonomyFragment[]
  itemToHighlight?: { supplementId: number } | null
  noBorder: boolean
  readonly: boolean
  date: moment.Moment
  frequency: string
  hover: boolean
  toggleTaxonomyCreationModal: (value: boolean) => void
}

const SupplementsFormsList = ({
  employee,
  effectiveOn,
  store,
  taxonomies,
  itemToHighlight,
  readonly = false,
  date,
  frequency,
  hover,
  toggleTaxonomyCreationModal,
}: Props) => {
  const forms = store.formsFor(employee, effectiveOn)

  if (!forms.length) return null

  return (
    <Box paddingX="s24" aria-label="supplement-item-forms">
      <FormGroups
        forms={forms}
        store={store}
        taxonomies={taxonomies}
        itemToHighlight={itemToHighlight}
        readonly={readonly}
        date={date}
        frequency={frequency}
        hover={hover}
        toggleTaxonomyCreationModal={toggleTaxonomyCreationModal}
      />
    </Box>
  )
}

export default observer(SupplementsFormsList)
